import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails, GetPaymentRequestDTO, PaymentsResponse } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class GetPaymentsByCurrentAccountsCommand extends IRequestCommand<
  IGetPaymentsByCurrentAccountsResponse,
  ErrorDetails,
  IGetPaymentsByCurrentAccountsCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl =
    'carriers/{carrierUserId}/passenger/{passengerUserId}/checkingAccount/payments/paginated?page={page}&size={size}&column={column}&sort={sort}';
  public override setParameters(
    parameters: IGetPaymentsByCurrentAccountsCommandParameters
  ) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      String(parameters.carrierUserId)
    );
    this._commandUrl = this._commandUrl.replace(
      '{passengerUserId}',
      String(parameters.passengerUserId ?? '')
    );
    this._commandUrl = this._commandUrl.replace(
      '{page}',
      String(parameters.page ?? 1)
    );
    this._commandUrl = this._commandUrl.replace(
      '{size}',
      String(parameters.size ?? 10)
    );
    this._commandUrl = this._commandUrl.replace(
      '{column}',
      String(parameters.column ?? '')
    );
    this._commandUrl = this._commandUrl.replace(
      '{sort}',
      String(parameters.sort ?? '')
    );
  }
}

export interface IGetPaymentsByCurrentAccountsCommandParameters
  extends ICommandParameters,
    GetPaymentRequestDTO {}

export interface IGetPaymentsByCurrentAccountsResponse
  extends PaymentsResponse,
    ICommandResponse {}
